module.exports = __webpack_public_path__ + "img/couples_02_V.be2b7896.webp";